( function () {
	'use strict';

	function initSlider( container ) {
		var desktopViewport = container.querySelector( '.kerawa-hero-slider__viewport--desktop' );
		var mobileViewport  = container.querySelector( '.kerawa-hero-slider__viewport--mobile' );

		if ( ! desktopViewport && ! mobileViewport ) {
			return;
		}

		var desktopSlides = desktopViewport
			? Array.from( desktopViewport.querySelectorAll( '.kerawa-hero-slider__slide' ) )
			: [];
		var mobileSlides = mobileViewport
			? Array.from( mobileViewport.querySelectorAll( '.kerawa-hero-slider__slide' ) )
			: [];

		var slideCount = desktopSlides.length || mobileSlides.length;

		if ( slideCount === 0 ) {
			return;
		}

		var contentPanels = container.querySelectorAll( '.kerawa-hero-slider__content' );
		var dots          = container.querySelectorAll( '.kerawa-hero-slider__dot' );

		var autoPlayInterval = parseInt(
			container.getAttribute( 'data-auto-play-interval' ),
			10
		) || 5000;

		var dotActiveColor =
			container.getAttribute( 'data-dot-active-color' ) || '#C9A84C';

		var currentIndex = 0;
		var timer = null;
		var isPaused = false;

		function goToSlide( index ) {
			if ( index < 0 || index >= slideCount ) {
				return;
			}

			// Deactivate current.
			if ( desktopSlides[ currentIndex ] ) {
				desktopSlides[ currentIndex ].classList.remove( 'is-active' );
			}
			if ( mobileSlides[ currentIndex ] ) {
				mobileSlides[ currentIndex ].classList.remove( 'is-active' );
			}
			dots[ currentIndex ].classList.remove( 'is-active' );
			dots[ currentIndex ].style.backgroundColor = '';
			if ( contentPanels[ currentIndex ] ) {
				contentPanels[ currentIndex ].classList.remove( 'is-active' );
			}

			currentIndex = index;

			// Activate next.
			if ( desktopSlides[ currentIndex ] ) {
				desktopSlides[ currentIndex ].classList.add( 'is-active' );
			}
			if ( mobileSlides[ currentIndex ] ) {
				mobileSlides[ currentIndex ].classList.add( 'is-active' );
			}
			dots[ currentIndex ].classList.add( 'is-active' );
			dots[ currentIndex ].style.backgroundColor = dotActiveColor;
			if ( contentPanels[ currentIndex ] ) {
				contentPanels[ currentIndex ].classList.add( 'is-active' );
			}
		}

		function nextSlide() {
			var next = ( currentIndex + 1 ) % slideCount;
			goToSlide( next );
		}

		function startAutoPlay() {
			if ( timer ) {
				clearInterval( timer );
			}
			timer = setInterval( function () {
				if ( ! isPaused ) {
					nextSlide();
				}
			}, autoPlayInterval );
		}

		function stopAutoPlay() {
			if ( timer ) {
				clearInterval( timer );
				timer = null;
			}
		}

		// Initialise first desktop slide.
		desktopSlides.forEach( function ( slide, i ) {
			if ( i === 0 ) {
				slide.classList.add( 'is-active' );
			} else {
				slide.classList.remove( 'is-active' );
			}
		} );

		// Initialise first mobile slide.
		mobileSlides.forEach( function ( slide, i ) {
			if ( i === 0 ) {
				slide.classList.add( 'is-active' );
			} else {
				slide.classList.remove( 'is-active' );
			}
		} );

		contentPanels.forEach( function ( panel, i ) {
			if ( i === 0 ) {
				panel.classList.add( 'is-active' );
			} else {
				panel.classList.remove( 'is-active' );
			}
		} );

		dots.forEach( function ( dot, i ) {
			if ( i === 0 ) {
				dot.classList.add( 'is-active' );
				dot.style.backgroundColor = dotActiveColor;
			} else {
				dot.classList.remove( 'is-active' );
				dot.style.backgroundColor = '';
			}
		} );

		// Dot click handlers.
		dots.forEach( function ( dot, i ) {
			dot.addEventListener( 'click', function () {
				goToSlide( i );
				stopAutoPlay();
				startAutoPlay();
			} );
		} );

		// Pause on hover.
		container.addEventListener( 'mouseenter', function () {
			isPaused = true;
		} );

		container.addEventListener( 'mouseleave', function () {
			isPaused = false;
		} );

		// Start auto-play if more than one slide.
		if ( slideCount > 1 ) {
			startAutoPlay();
		}
	}

	function init() {
		var sliders = document.querySelectorAll(
			'.wp-block-kerawa-hero-slider'
		);
		sliders.forEach( function ( slider ) {
			initSlider( slider );
		} );
	}

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}
} )();
